export default __webpack_public_path__ + "static/media/icon-coin-stx.be924b45.svg";